/**
 * Session related types
 * Shared between frontend and backend
 */
export const SESSION_CREATION_LIMITS = {
    free: 1,
    starter: 5,
    team: "unlimited",
};
